import { combineReducers } from 'redux';
import marketStack from './marketplace.reducer';

const reducer = combineReducers({
	marketStack
});

export default reducer;
